export default $axios => ({
  check(params) {
    return $axios.$get('/v2/postal-codes/check', { params })
  },
  getServiceName: () => 'postalCodeService',
})
